import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { getEmptyFormValues, useFormAPI } from "@/widgets/classic-form/form";
import { populateFormValuesFromMetadata } from "@/widgets/classic-form/metadata-converters/populateFormValuesFromMetadata";
import { useMetadataQuery } from "@/entities/form-metadata";
import { useResetValidationErrors } from "@/shared/forms";

interface ClearProps {
    disabled: boolean;
    label?: string;
}

export const Clear = ({ label, disabled }: ClearProps) => {
    const { t } = useTranslation();
    const formApi = useFormAPI();
    const { data: formMetadata } = useMetadataQuery();
    const resetValidationErrors = useResetValidationErrors();

    const clearForm = useCallback(() => {
        const clearedFormValues = populateFormValuesFromMetadata({
            isEditForm: false,
            formMetadata,
            sourceFormValues: getEmptyFormValues(),
            matchAllTermsExactly: false,
        });
        formApi.reset(clearedFormValues);
        resetValidationErrors();
    }, [formApi, formMetadata, resetValidationErrors]);

    return (
        <button
            onClick={clearForm}
            className="ancBtn silver"
            type="button"
            disabled={disabled}
            data-testid="clear-form"
        >
            {label ?? t("searchForm.clear")}
        </button>
    );
};
